import { useState } from "react";

import AssistantRenameInline from "./AssistantName/AssistantRenameInline";

import { PencilIcon } from "@heroicons/react/24/outline";
import { LockClosedIcon } from "@heroicons/react/24/solid";

import { useAssistantsContext } from "V2.0/Context/AssistantsContext";
import clsx from "clsx";

function AssistantName(props) {
  const { name, assistantId, workspaceId, syncAssistant, locked } = props;
  const { fetchAssistants } = useAssistantsContext();

  const [editName, setEditName] = useState<boolean>(false);

  if (editName) {
    return (
      <AssistantRenameInline
        assistantName={name}
        assistantId={assistantId}
        workspaceId={workspaceId}
        onDone={() => setEditName(false)}
        onUpdatedName={(name) => {
          syncAssistant((prevAssistant) => {
            return {
              ...prevAssistant,
              name,
            };
          });

          fetchAssistants(workspaceId, false);
        }}
      />
    );
  }

  return (
    <div
      className={clsx(
        "flex items-center gap-2 text-base font-medium text-gray-900",
        !locked && "hover:underline cursor-pointer"
      )}
      onClick={
        !locked
          ? () => {
              setEditName(true);
            }
          : () => {}
      }
    >
      {name}
      {!locked && <PencilIcon className="w-4 h-4 text-gray-500" />}
      {locked && <LockClosedIcon className="w-4 h-4 text-red-500 font-bold" />}
    </div>
  );
}

export default AssistantName;
